import { createReducer } from '@reduxjs/toolkit';

import getEbayTaskResultFile from '../../thunks/ebay/getEbayTaskResultFile';

const initialState = {
  loading: false,
  error: null,
  resultFile: undefined,
};

const getEbayTaskResultFileReducer = createReducer(initialState, {
  [getEbayTaskResultFile.pending]: (state) => ({
    ...state,
    loading: true,
    error: null
  }),
  [getEbayTaskResultFile.fulfilled]: (state, { payload: { file } }) => ({
    ...state,
    loading: false,
    resultFile: file,
  }),
  [getEbayTaskResultFile.rejected]: (state, { payload }) => ({
    ...state,
    loading: false,
    error: payload,
  }),
});

export default getEbayTaskResultFileReducer;
